import {
  PageHeader,
  Tabs,
  TabsList,
  TabsTrigger,
} from '@/components/molecules';
import {
  ProfileTab,
  BusinessTab,
  BankInfoTab,
  SecurityTab,
  NotificationTab,
  SubscriptionTab,
  // AiSettingsTab,
  PreferencesTab,
} from './components';
import { useQueryState } from 'nuqs';

export const SettingsPage = () => {
  const [tab, setTab] = useQueryState('tab', { defaultValue: 'profile' });

  return (
    <div className="flex flex-col gap-6 w-full">
      <PageHeader
        heading="Account Settings"
        description="Manage your account settings and preferences"
      />

      <Tabs value={tab} onValueChange={setTab}>
        <div className="overflow-hidden flex">
          <TabsList className="py-3 overflow-scroll justify-start">
            <TabsTrigger value="profile">Profile</TabsTrigger>
            <TabsTrigger value="business">Business Information</TabsTrigger>
            <TabsTrigger value="bank-info">Bank Information</TabsTrigger>
            {/* <TabsTrigger value="ai-settings">AI Settings</TabsTrigger> */}
            <TabsTrigger value="security">Security</TabsTrigger>
            <TabsTrigger value="notification">Notifications</TabsTrigger>
            <TabsTrigger value="subscription">Subscription</TabsTrigger>
            <TabsTrigger value="preferences">Preferences</TabsTrigger>
          </TabsList>
        </div>

        <ProfileTab />
        <BusinessTab />
        <BankInfoTab />
        <SecurityTab />
        <NotificationTab />
        <SubscriptionTab />
        {/* <AiSettingsTab /> */}
        <PreferencesTab />
      </Tabs>
    </div>
  );
};
